// extracted by mini-css-extract-plugin
export default {"mainIframeWidth":"375px","closeButton":"styles__d2b856498561dfcaa46a"};